<template>
  <v-app id="app">
    <navigation-drawer v-if="isNavigationVisible" />
    <v-main>
      <router-view />
    </v-main>
    <right-side-contents v-if="isSidebarVisible" />
  </v-app>
</template>

<script>
import NavigationDrawer from "./components/NavigationDrawer";
import RightSideContents from "./components/RightSideContents";
export default {
  name: "app",
  components: {
    NavigationDrawer,
    RightSideContents
  },
  data() {
    return {};
  },
  computed: {
    isNavigationVisible() {
      return (
        this.$store.getters.isNavigationVisible === true &&
        this.$route.path === "/"
      );
    },
    isSidebarVisible() {
      return (
        this.$store.getters.isRightNavVisible === true &&
        this.$route.path === "/"
      );
    },
    isMobile() {
      return this.$route.path === "/mobile";
    },
    baseDate() {
      return this.$store.getters.baseDate;
    }
  },
  created() {
    this.fetchAlerts();
    const data = localStorage.getItem("enabledObservatories");
    if (data) {
      this.$store.commit("SET_RISK_SUB_CONTROL", {
        observatory: JSON.parse(data)
      });
    }
  },
  watch: {
    async baseDate(newVal, oldVal) {
      if (newVal.isSame(oldVal)) return;
      this.fetchAlerts();
    }
  },
  methods: {
    fetchAlerts() {
      this.$store.dispatch("FETCH_ALERTS");
      this.$store.dispatch("FETCH_ALERT_STATUS");
    }
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
img {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: pixelated;
  -ms-interpolation-mode: nearest-neighbor;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: crisp-edges;
}
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar {
  width: 0px;
}
.leaflet-bottom.leaflet-right {
  .leaflet-control-attribution.leaflet-control {
    pointer-events: painted !important;
  }
}
.v-dialog__content.v-dialog__content--active,
.v-overlay.v-overlay--active {
  z-index: 1001 !important;
}
</style>
